import React from 'react';
import { Star } from 'lucide-react';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="bg-forest-green text-cream pt-8 pb-10 px-4 relative overflow-hidden" data-id="element-112">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#FAF8F5 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-113"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative z-10" data-id="element-114">
        <div className="space-y-4 text-center md:text-left" data-id="element-115">
          <div className="space-y-3" data-id="element-116">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-gold/20 to-green-accent/30 text-gold-light px-4 py-2 rounded-full text-sm font-bold border border-gold/30 shadow-sm" data-id="element-117">
              <div className="flex" data-id="element-118">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold drop-shadow-sm" data-id="element-119" />)}
              </div>
              <span className="ml-1 tracking-wide" data-id="element-120">
                Más de 3,800 mascotas transformadas
              </span>
            </div>

            <p className="text-gold font-black tracking-widest uppercase text-xs md:text-sm drop-shadow-sm" data-id="element-121">
              Alimenta Con Amor
            </p>

            <div className="relative inline-block" data-id="element-122">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.1] text-balance font-serif drop-shadow-md" data-id="element-123">
                Tu perro merece vivir más años, con más energía
              </h1>
              <div className="absolute -bottom-2 left-0 w-1/3 h-1.5 bg-gold rounded-full opacity-80 md:left-0 left-1/2 md:translate-x-0 -translate-x-1/2" data-id="element-124"></div>
            </div>
          </div>

          <p className="text-lg md:text-xl text-cream/95 font-medium max-w-xl mx-auto md:mx-0 leading-relaxed" data-id="element-125">
            Transforma la vida de tu mascota en 7 días · Incluso si nunca
            cocinaste para ellos antes.
          </p>

          <div className="pt-3" data-id="element-126">
            <Button fullWidth className="md:w-auto shadow-glow-lg" data-id="element-127">
              QUIERO TRANSFORMAR A MI MASCOTA AHORA
            </Button>
            <p className="mt-3 text-sm text-cream/80 flex items-center justify-center md:justify-start gap-2 font-bold tracking-wide" data-id="element-128">
              <span className="w-2.5 h-2.5 rounded-full bg-green-400 shadow-[0_0_8px_rgba(74,222,128,0.8)]" data-id="element-129"></span>
              Acceso inmediato digital · Pago único
            </p>
          </div>
        </div>

        <div className="relative mt-4 md:mt-0" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/rCNubuYHEVfNusg35qRpRX/20260318_0837_Image_Generation_simple_compose_01km0brbf1f1zrvz1k9zcwrpya_(1)_(1).webp" alt="Perro y gato felices con comida natural" className="relative z-10 rounded-2xl shadow-2xl border-4 border-gold/30 object-cover aspect-square md:aspect-[4/5]" loading="eager" fetchPriority="high" data-id="element-131" />
          <div className="absolute -bottom-4 -left-3 md:-left-8 bg-white text-forest-green p-4 rounded-xl shadow-xl z-20 flex items-center gap-3 max-w-[280px] border-2 border-gold/20" data-id="element-132">
            <div className="bg-green-50 p-2.5 rounded-full flex-shrink-0 border border-green-100" data-id="element-133">
              <Star className="w-6 h-6 text-green-600 fill-green-600" data-id="element-134" />
            </div>
            <div data-id="element-135">
              <p className="text-[11px] font-black text-gold uppercase tracking-widest mb-0.5" data-id="element-136">
                Garantía
              </p>
              <p className="text-sm md:text-base font-bold leading-tight" data-id="element-137">
                Resultados visibles en 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}